module.exports = __webpack_public_path__ + "img/phone-icon.caa353d.svg";